import React from 'react';
import styled from 'styled-components';
import { HeaderTitle, Colors } from '../../../utils/budget-tool-specific';
import PassportList from './passport-list';

const Passport = (props) => {
    return (
        <PageContainer>
            <HeaderTitle>
                Passport Guides
            </HeaderTitle>
            <DisclaimerText>
                Information is provided as guidance only and accurate at the time of publishing. Always check government websites and airline materials before booking and traveling.
            </DisclaimerText>
            <PassportList/>
        </PageContainer>
    );
};

export default Passport;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;

const DisclaimerText = styled.div`
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 15px;
    margin: 15px 0;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
`;

const ButtonRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
    padding: 0 15px;
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
`;

const PrimaryButton = styled.button`
    background-color: ${Colors.primaryAccent};
    color: ${Colors.primaryDark};
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${Colors.primaryAccent}dd;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const SaveButton = styled.button`
    background-color: ${Colors.primary};
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${Colors.primaryDark};
    }
`;

const CopyButton = styled.button`
    background-color: ${Colors.primaryLight};
    color: ${Colors.primaryDark};
    border: 1px solid ${Colors.primaryDark}20;
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${Colors.primaryLight}dd;
    }
`;